import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

/**
 * Common form fields shared between Individual and Organization forms
 */
export const CommonFields = ({ formData, onChange }) => (
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label htmlFor="name" className="text-zinc-400 text-xs uppercase tracking-wider">
          Your Name *
        </Label>
        <Input
          id="name"
          name="name"
          value={formData.name}
          onChange={onChange}
          data-testid="contact-name"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="John Doe"
          required
        />
      </div>
      <div>
        <Label htmlFor="email" className="text-zinc-400 text-xs uppercase tracking-wider">
          Email Address *
        </Label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={onChange}
          data-testid="contact-email"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="john@example.com"
          required
        />
      </div>
    </div>

    <div>
      <Label htmlFor="phone" className="text-zinc-400 text-xs uppercase tracking-wider">
        Phone Number
      </Label>
      <Input
        id="phone"
        name="phone"
        type="tel"
        value={formData.phone}
        onChange={onChange}
        data-testid="contact-phone"
        className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
        placeholder="+1 (604) 555-0123"
      />
    </div>
  </>
);

/**
 * Individual-specific form fields
 */
export const IndividualFields = ({ formData, onChange }) => (
  <>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label htmlFor="sport" className="text-zinc-400 text-xs uppercase tracking-wider">
          Sport / Activity
        </Label>
        <Input
          id="sport"
          name="sport"
          value={formData.sport}
          onChange={onChange}
          data-testid="contact-sport"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="e.g., Soccer, Basketball"
        />
      </div>
      <div>
        <Label htmlFor="athlete_name" className="text-zinc-400 text-xs uppercase tracking-wider">
          Athlete's Name
        </Label>
        <Input
          id="athlete_name"
          name="athlete_name"
          value={formData.athlete_name}
          onChange={onChange}
          data-testid="contact-athlete-name"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="If inquiring for an athlete"
        />
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label htmlFor="athlete_age" className="text-zinc-400 text-xs uppercase tracking-wider">
          Athlete's Age
        </Label>
        <Input
          id="athlete_age"
          name="athlete_age"
          type="number"
          min="5"
          max="30"
          value={formData.athlete_age}
          onChange={onChange}
          data-testid="contact-athlete-age"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="Age"
        />
      </div>
    </div>
  </>
);

/**
 * Organization-specific form fields
 */
export const OrganizationFields = ({ formData, onChange }) => (
  <>
    <div>
      <Label htmlFor="organization_name" className="text-zinc-400 text-xs uppercase tracking-wider">
        Organisation Name *
      </Label>
      <Input
        id="organization_name"
        name="organization_name"
        value={formData.organization_name}
        onChange={onChange}
        data-testid="contact-org-name"
        className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
        placeholder="e.g., Vancouver Youth Soccer Club"
        required
      />
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label htmlFor="organization_sport" className="text-zinc-400 text-xs uppercase tracking-wider">
          Which Sport Does Your Organisation Represent?
        </Label>
        <Input
          id="organization_sport"
          name="organization_sport"
          value={formData.organization_sport}
          onChange={onChange}
          data-testid="contact-org-sport"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="e.g., Soccer, Hockey, Multi-sport"
        />
      </div>
      <div>
        <Label htmlFor="number_of_athletes" className="text-zinc-400 text-xs uppercase tracking-wider">
          Number of Athletes
        </Label>
        <Input
          id="number_of_athletes"
          name="number_of_athletes"
          type="number"
          min="1"
          value={formData.number_of_athletes}
          onChange={onChange}
          data-testid="contact-num-athletes"
          className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white"
          placeholder="e.g., 50"
        />
      </div>
    </div>
  </>
);

/**
 * Message field component
 */
export const MessageField = ({ value, onChange, placeholder }) => (
  <div>
    <Label htmlFor="message" className="text-zinc-400 text-xs uppercase tracking-wider">
      Message *
    </Label>
    <Textarea
      id="message"
      name="message"
      value={value}
      onChange={onChange}
      data-testid="contact-message"
      className="mt-2 bg-zinc-900/50 border-white/10 focus:border-[#56C6C6] text-white min-h-[150px]"
      placeholder={placeholder}
      required
    />
  </div>
);
